import ApiService from "@/core/services/api.service";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

// action types
export const LIFECYCLES_LIST = "lifecycles_list";
export const CREATE_LIFECYCLES = "create_lifecycles";
export const UPDATE_LIFECYCLES = "update_lifecycles";
export const DELETE_LIFECYCLES = "delete_lifecycles";
export const GET_LIFECYCLES_DETAILS = "get_lifecycles_details";
export const LIFECYCLES_SIMPLE_LIST = "lifecycles_simple_details";
export const CLEAR_LIFECYCLES_ERRORS = "clearLifeCyclesErrors";

// mutation types
export const SET_LIFECYCLES_ERROR = "setLifeCyclesErrors";
export const REMOVE_LIFECYCLES_ERRORS = "removeLifeCyclesErrors";

const state = {
    errors: null
};
const actions = {
    [LIFECYCLES_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simpledatatable("api/lifecycles?" + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_LIFECYCLES_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_LIFECYCLES_ERROR, response.errors);
                });
        });
    },
    [CREATE_LIFECYCLES](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/createlifecycle", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_LIFECYCLES_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_LIFECYCLES_ERROR, response.errors);
                });
        });
    },
    [UPDATE_LIFECYCLES](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updatelifecycle", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_LIFECYCLES_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_LIFECYCLES_ERROR, response.errors);
                });
        });
    },
    [DELETE_LIFECYCLES](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/deletelifecycle", payload).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_LIFECYCLES_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_LIFECYCLES_ERROR, response.errors);
                });
        });
    },
    [GET_LIFECYCLES_DETAILS](context, id) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/getlifecycledetail", id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_LIFECYCLES_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_LIFECYCLES_ERROR, response.errors);
                });
        });
    },
    [CLEAR_LIFECYCLES_ERRORS](context) {
        context.commit(REMOVE_LIFECYCLES_ERRORS);
    },
    [LIFECYCLES_SIMPLE_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/lifecyclessimple?type=" + payload.type)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    }
                }).catch(({response}) => {
                context.commit(SET_LIFECYCLES_ERROR, response.errors);
            });
        });
    },
};

const mutations = {
    [SET_LIFECYCLES_ERROR](state, error) {
        state.errors = error;
    },
    [REMOVE_LIFECYCLES_ERRORS](state) {
        state.errors = {};
    }
};

export default {
    state,
    actions,
    mutations
};
